module.exports = __webpack_public_path__ + "img/list2.7dd06e8c.jpg";